import '.f8{max-width:560px;}.ssr-plugin'
import '.f9{min-width:100%;}.ssr-plugin'
import '.c0{padding:48px;}.ssr-plugin'
import '.o{display:flex;}.ssr-plugin'
import '.p{flex-direction:column;}.ssr-plugin'
import '.fa{height:calc(100vh - 124px);}.ssr-plugin'
import '.bb{justify-content:center;}.ssr-plugin'
import '.ag{box-sizing:border-box;}.ssr-plugin'
import '.aw{text-align:center;}.ssr-plugin'
import '.fb{margin-bottom:76px;}.ssr-plugin'
import '.aq{display:block;}.ssr-plugin'
import '.cr{margin-bottom:24px;}.ssr-plugin'
import { styled } from 'inlines'
import { useState } from 'react'
import { createPortal } from 'react-dom'
import { colors } from '../../utils/colors.js'
import { Button } from '../../components/Button.js'
import { Icon } from '../../assets/icons/index.js'
import { useTrack } from '../../hooks/useTrack.js'
import { AnalyticsEvent } from '../../../../shared/analyticsEvents.js'
import {
  useVotingRegion,
  useVotingRegionName,
} from '../../hooks/useVotingRegion.js'
import { useLanguage } from '../../hooks/useLanguage.js'
import { MenuVotingRegion } from '../../components/MenuVotingRegion.js'
import { MENU_IN_FROM_BOTTOM } from '../../utils/animations.js'
import { TABLET, MOBILE, HEIGHT } from '../../utils/breakpoints.js'
import { interpolate } from '../../utils/interpolate.js'
import { transparentColor } from '../../utils/transparentcolor.js'

export const StepOne = ({
  step,
  setStep,
  dictionary,
  setOpenLangSelectModal,
  setOpenRegionModal,
}) => {
  const track = useTrack('onboarding')

  const [lang] = useLanguage()
  const [votingRegion] = useVotingRegion()
  const votingRegionName = useVotingRegionName(votingRegion?.code)

  const [openLangMenu, setOpenLangMenu] = useState(false)

  const [menuPos, setMenuPos] = useState({ x: 0, y: 0, width: 374 })

  return (
    <>
      <styled.div className="f8 f9 c0 o p fa bb ag"
        id="onboarding-step-one-content"
        style={{
          [TABLET]: {
            padding: '24px',
          },
          [MOBILE]: {
            height: 'calc(100dvh - 124px)',
            boxSizing: 'border-box',
            justifyContent: 'flex-end',
          },
        }}
      >
        <styled.h1 className="aw fb"
          style={{
            [MOBILE]: {
              marginTop: '0px',
              marginBottom: '0px',
              paddingTop: '72px',
              flex: 1,
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
            },
            [HEIGHT]: {
              marginBottom: '12px',
            },
          }}
        >
          {dictionary.visitingFrom
            ?.split(/<accent>(.*?)<\/accent>/g)
            .map((part, i) =>
              i % 2 === 1 ? (
                <span className="aq aw"
                  style={{
                    color: colors.primary,}}
                  key={i}
                >
                  {part}
                </span>
              ) : (
                part
              ),
            )}
        </styled.h1>

        <p className="cr aw">
          {votingRegion?.code === 'SM' ? (
            interpolate(dictionary.notAllowedToVote, { votingRegionName })
          ) : votingRegion?.overseaSource ? (
            <>
              {interpolate(dictionary.votingOnBehalf, {
                votingRegionName,
              })}
            </>
          ) : votingRegion?.voteType === 'call_suffix' ? (
            dictionary.onlyCallVotingSupported
          ) : votingRegion?.voteType === 'sms_text' ||
            votingRegion?.voteType === 'sms_suffix' ? (
            dictionary.onlySMSVotingSupported
          ) : (
            interpolate(dictionary.cardLocationNotice, {
              votingRegionName,
            })
          )}
        </p>
        <Button
          ariaLabel="open-language-regionmenu"
          id="onboarding-step-one-action-open-menu-modal"
          leadIcon={<Icon type="globeIcon" />}
          trailIcon={<Icon type="chevronDownIcon" />}
          fullWidth
          style={{ marginBottom: 16, textAlign: 'left' }}
          onClick={(e) => {
            track(AnalyticsEvent.ONBOARDING_CLICK, 'lang-menu-open')
            const rect = e.currentTarget.getBoundingClientRect()

            setMenuPos({
              x: rect.left,
              y: rect.top,
              width: rect.width,
            })
            setOpenLangMenu(!openLangMenu)
          }}
          variant="border"
        >
          {votingRegionName} · {lang?.name}
        </Button>
        {votingRegion?.code !== 'SM' && (
          <Button
            ariaLabel={dictionary?.continueButton}
            id="onboarding-step-one-action-open-step-two"
            trailIcon={<Icon type="forwardIcon" color={colors.secondary} />}
            fullWidth
            onClick={() => setStep(step + 1)}
          >
            {dictionary?.continueButton}
          </Button>
        )}
      </styled.div>
      {openLangMenu &&
        createPortal(
          <MenuVotingRegion
            id="onboarding-step-one-menu-modal"
            triggerId="onboarding-step-one-action-open-menu-modal"
            setOpen={setOpenLangMenu}
            setOpenLangSelectModal={setOpenLangSelectModal}
            setOpenRegionModal={setOpenRegionModal}
            animation={MENU_IN_FROM_BOTTOM}
            style={{
              top: 'unset',
              bottom: window.innerHeight - menuPos.y + 8,
              left: menuPos.x,
              maxWidth: menuPos.width - 46,
              width: '100%',
              backgroundColor: transparentColor(colors.secondary, 0.24),
            }}
          />,
          document.body,
        )}
    </>
  )
}
